import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import green_tick from "../../../images/green_tick.png";
import tick from "../../../images/tick.png";
import cross_icon from "../../../images/red_cross.png";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import countriesData from "../../../data/countries.json";
import { useEffect, useState } from "react";
import countriesStateData from "../../../data/states.json";
import { toHaveFormValues } from "@testing-library/jest-dom/matchers";
import BackButton from "../../Includes/BackButtonEntityAccount";

import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setAccountUseDetails,
  setwizardPageNumber,
  setwizardPageName,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
  setBusinessAddressDetails,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError, notifySuccess } from "MyComponents/Toaster";
import config from "../../../config";
import axios, { AxiosError } from "axios";
import { updateEntityKycDraftStep } from "../../../Utils/entityKycDraft";
import { initial } from "lodash";
import { useTranslation } from "react-i18next";

interface Props { }

interface CheckboxState {
  checkbox1: boolean;
  checkbox2: boolean;
  checkbox3: boolean;
  checkbox4: boolean;
  checkbox5: boolean;
  checkbox6: boolean;
  checkbox7: boolean;
  checkbox8: boolean;
  checkbox9: boolean;
  checkbox10: boolean;
  checkbox11: boolean;
}

const checkboxLabels: { [key: string]: string } = {
  checkbox1: "US",
  checkbox2: "UK",
  checkbox3: "Africa",
  checkbox4: "Other Oceania",
  checkbox5: "Canada",
  checkbox6: "EU",
  checkbox7: "Asia",
  checkbox8: "Not applicable",
  checkbox9: "LATAM",
  checkbox10: "Other Europe",
  checkbox11: "Australia",
};

interface FormData {
  reasonForUsingAccount: string;
}

const AccountUseForm: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const email = useSelector((state: RootState) => state.entityAccount.email);
  const entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );
  const { userId } = useParams<{ userId?: string }>();

  const [checkboxes, setCheckboxes] = useState<CheckboxState>({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    checkbox5: false,
    checkbox6: false,
    checkbox7: false,
    checkbox8: false,
    checkbox9: false,
    checkbox10: false,
    checkbox11: false,
  });

  useEffect(() => {
    dispatch(setwizardPageName("accountUse"));
  }, [dispatch]);

  useEffect(() => {
    const initial = props.initialValues?.accountUseCustomerLocated;

    if (!initial || typeof initial !== "string") return;

    const selectedCountries = initial
      .split(",")
      .map((c: string) => c.trim());

    const updatedCheckboxes: CheckboxState = Object.entries(checkboxLabels).reduce(
      (acc, [key, country]) => {
        acc[key as keyof CheckboxState] = selectedCountries.includes(country);
        return acc;
      },
      {} as CheckboxState
    );

    setCheckboxes(updatedCheckboxes);
  }, [props.initialValues?.accountUseCustomerLocated]);


  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    setValidated(false);
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));
  };

  const isAtLeastOneCheckboxChecked = Object.values(checkboxes).some(
    (isChecked) => isChecked
  );

  const [validated, setValidated] = useState(false);

  const validateReasonForAccountUse = (value: any) => {
    if (!value) {
      return "Reason is required";
    }
  };

  const saveAccountUseDetails = async (
    ssoUserID: string,
    email: String,
    reasonForUsingAccount: String,
    accountUseCustomerLocated: String
  ) => {
    try {
      const payload = {
        email,
        reasonForUsingAccount,
        accountUseCustomerLocated
      };

      const response = await updateEntityKycDraftStep(ssoUserID, "accountUse", payload);
      return response;
    } catch (error: any) {
      console.error(error);
      notifyError("Something Went Wrong");
      return null;
    }
  };

  const submitAccountUseForm = async (formValues: FormData) => {

    if (!isAtLeastOneCheckboxChecked) {
      setValidated(true);
    } else {
      const checkedCheckboxes = Object.entries(checkboxes)
        .filter(([key, value]) => value)
        .map(([key]) => checkboxLabels[key]);

      const accountUseCustomerLocated = checkedCheckboxes.join(", ");

      const reasonForUsingAccount = formValues.reasonForUsingAccount;
      const ssoUserID = userId || "";

      const accountUseDetailsObject = {
        reasonForUsingAccount: reasonForUsingAccount,
        accountUseCustomerLocated: accountUseCustomerLocated,
      };
      console.log("Account Use Details: ", accountUseDetailsObject);

      const Response = await saveAccountUseDetails(
        ssoUserID,
        email,
        reasonForUsingAccount,
        accountUseCustomerLocated
      );
      console.log("Response", Response);
      if (Response) {
        dispatch(setAccountUseDetails(accountUseDetailsObject));
        dispatch(setwizardPageName("successBusinessInfo"));
        dispatch(setwizardPageNumber(6));
        localStorage.setItem('pageName', "successBusinessInfo");
        localStorage.setItem('pageNumber', '6');
      }
    }
  };

  return (
    <>
      <div className="pt-0 pb-3 mb-5 col-md-11 mx-auto px-2">
        <div className="row justify-content-center">
          <Col md={11}>
            <p className=" fw-bold  d-inline">{t('kyc.entity_account_app')}</p>
            <p className="text-warning d-inline ms-3 small">{t('common.in_progress')}</p><br />
            <label className=" form-label mt-3 fw-bold">{t('kyc.entity_nav_account_use')}</label>
            <p className="text-secondary small">
              {t('kyc.account_use_desc')}
            </p>
          </Col>
        </div>

        <div className="row justify-content-center">
          <Col md={11}>
            <Form
              noValidate={true}
              onSubmit={handleSubmit(submitAccountUseForm)}
            >
              <div className="mt-4 row mb-3">
                <Col md={12}>
                  <label className="form-label  fw-bold ">
                    {t('kyc.account_use_reason_q')}
                  </label>
                  <p className="text-secondary small">
                    {t('kyc.account_use_examples')}
                  </p>
                </Col>
              </div>
              <div className="row mb-3 mt-4">
                <Field
                  name="reasonForUsingAccount"
                  type="text"
                  component={renderField}
                  shouldRound={false}
                  placeholder={t('kyc.account_use_reason_ph')}
                  id="reasonForUsingAccount"
                  validate={validateReasonForAccountUse}
                />
              </div>

              <div className="mb-3 mt-4 row">
                <Col md={12}>
                  <p className=" fw-bold  d-inline">
                    {t('kyc.customers_located_q')}
                  </p>
                  <p className="text-warning d-inline ms-3 small">
                    {t('kyc.requires_one_selection')}
                  </p>
                </Col>

                {validated && (
                  <p className="text-danger text-start small fw-bold">
                    {t('common.please_check_one')}
                  </p>
                )}

                <div className="col-md-4 mt-2">
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox1"
                      label="US"
                      checked={checkboxes.checkbox1}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>

                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox2"
                      label="UK"
                      checked={checkboxes.checkbox2}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox3"
                      label="Africa"
                      checked={checkboxes.checkbox3}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox4"
                      label="Other Oceania"
                      checked={checkboxes.checkbox4}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-2">
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox5"
                      label="Canada"
                      checked={checkboxes.checkbox5}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox6"
                      label="EU"
                      checked={checkboxes.checkbox6}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox7"
                      label="Asia"
                      checked={checkboxes.checkbox7}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox8"
                      label="Not Applicable"
                      checked={checkboxes.checkbox8}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-2">
                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox9"
                      label="LATAM"
                      checked={checkboxes.checkbox9}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>

                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox10"
                      label="Other Europe"
                      checked={checkboxes.checkbox10}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>

                  <div className="custom-checkbox">
                    <Form.Check
                      type="checkbox"
                      id="checkbox11"
                      label="Australia"
                      checked={checkboxes.checkbox11}
                      onChange={handleCheckboxChange}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3 mb-1">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="btn btn-secondary rounded-5  mt-2 border-0"
                    style={{ background: "#0B1628" }}
                  >
                    {t('common.save_continue')}
                  </Button>
                </Col>
              </div>
            </Form>
          </Col>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    reasonForUsingAccount: state.entityAccount.accountUseDetails.reasonForUsingAccount || "",
    accountUseCustomerLocated: state.entityAccount.accountUseDetails.accountUseCustomerLocated || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "wizardAccountUseinfo",
  enableReinitialize: true,
})(AccountUseForm);

export default connect(mapStateToProps)(form);
